module.exports = __webpack_public_path__ + "mv.38bc21fbd62efd98d03a.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/mv.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/mv.svg
// module chunks = styles